import type { ComponentWithAs, IconProps, GridProps } from "@chakra-ui/react";
import { Flex, Grid, Icon } from "@chakra-ui/react";
import React from "react";
import { TagWithTitle } from "../";
import type { TextPreset } from "../Text";
import { Text } from "../Text";
import type { IPropsTagWithTitle } from "../TagWithTitle";
import { IconChevronRightLight } from "@telefonica/mistica";

export interface IProps {
	icon: ComponentWithAs<"svg", IconProps>;
	iconSize?: number | string;
	description: string;
	tag?: IPropsTagWithTitle;
	textPreset?: TextPreset;
	textLineHeight?: string;
	textColor?: string;
	boxRowProps?: GridProps;
	iconColor?: string;
	textFontWeight?: "light" | "medium" | "regular";
	rightChevronColor?: string;
	onClick?(): void;
}

export const BoxRow: React.FC<IProps> = ({ icon, iconSize = 23, iconColor, description, onClick, tag, textPreset = "preset3", textFontWeight = "regular", boxRowProps, textLineHeight, textColor }) => {

	const textColorTag = {
		green: "greenAlpha",
		red: "redAlpha",
	};

	return (
		<Grid onClick={() => onClick ? onClick() : () => {}} borderRadius='5px' maxH={{ base: "80px", lg: "96px" }} display='flex' justifyContent='space-between' border='1px solid' borderColor='white.700' {...boxRowProps}>
			<Flex width='max' alignItems='center' justifyContent='center' gap={4}>
				<Icon
					as={icon}
					fill={iconColor ? iconColor : "primary"}
					color={iconColor ? iconColor : "primary"}
					w={iconSize}
					h={iconSize}
					margin='auto'
				/>
				<Flex h="48px" alignItems="center">
					<Text preset={textPreset} fontWeight={textFontWeight} mr='1.5' lineHeight={textLineHeight} color={textColor}>
						{description}
					</Text>
				</Flex>
			</Flex>
			<Flex alignItems='center'>
				{onClick && <IconChevronRightLight size={5} />}
				{tag && (
					<TagWithTitle
						bgColor={textColorTag[tag.color as keyof typeof textColorTag]}
						textColor={tag.textColor}
						title={tag.title}
						text={tag.text}
					/>
				)}
			</Flex>
		</Grid>
	);
};
